import { inject, Injectable } from '@angular/core';
import { selectTimezonesProperties } from '@core/state/timezones/timezones.selectors';
import { GetCurrentDateTimeByZone } from '@core/utils/current-time-by-zone-offset';
import { GetStandardStringDate } from '@core/utils/get-standard-string-date';
import { Store } from '@ngrx/store';
import { TimeZoneHelper } from '@shipmercury/mercury-ui';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';

import { GeolocationService } from '../geolocation/geolocation.service';

@Injectable({
  providedIn: 'root',
})
export class TimezoneService {
  timezonesProperties: any;
  destroyed$ = new Subject<void>();

  private store = inject(Store<any>);
  private service = inject(GeolocationService);

  constructor() {
    this.store
      .select(selectTimezonesProperties)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((item) => {
        this.timezonesProperties = item;
      });
  }

  async getTzIdentifier(address: any) {
    const validateTimezoneResponse: any = await firstValueFrom(
      this.service.validateTimezone(address)
    );

    let tzIdentifier = '';

    if (
      validateTimezoneResponse?.success &&
      validateTimezoneResponse?.data?.timeZoneId
    ) {
      tzIdentifier = validateTimezoneResponse.data.timeZoneId;
    } else {
      tzIdentifier = TimeZoneHelper.getLocalTimezone()?.tzIdentifier;
    }

    return tzIdentifier;
  }

  getCurrentDateOfAddress(address: any): Promise<string> {
    const addressInfo = {
      regionCode: address.regionCode,
      state: address.state,
      zipCode: address.zipCode,
      city: address.city,
    };

    return Promise.resolve(this.getTzIdentifier(addressInfo)).then((tz) => {
      const minShipDate = GetStandardStringDate(GetCurrentDateTimeByZone(tz));

      return minShipDate;
    });
  }
}
